import type { NodeViewProps } from '@tiptap/react';

import { cn } from '@repo/lib/cn';
import { NodeViewWrapper } from '@tiptap/react';

import { Image } from '@/components/ui/image';
import { RemoveFloatButton } from '@/components/ui/tiptap/tiptap-ui-primitives/remove-button';
import { ResizableButton, useResizableMedia } from '@/components/ui/tiptap/tiptap-ui-primitives/resizable-button';

export function ImageNodeComponent(imageNodeComponentProps: NodeViewProps) {
  const { node, editor, getPos, selected } = imageNodeComponentProps;
  const { title, src, alt, maxWidth, maxHeight, textAlign } = node.attrs;
  const isEditable: boolean = editor.isEditable;

  const { ref, containerRef, handleMediaLoad, handleMouseDown } = useResizableMedia<HTMLImageElement>(imageNodeComponentProps, (el) => ({
    width: el.naturalWidth,
    height: el.naturalHeight,
  }));

  const getImageStyle = () => {
    const style: React.CSSProperties = {};
    if (maxWidth) {
      style.maxWidth = `${maxWidth}px`;
    }
    if (maxHeight) {
      style.maxHeight = `${maxHeight}px`;
    }
    return style;
  };

  // Get container style based on alignment
  const getContainerStyle = (): React.CSSProperties => {
    switch (textAlign) {
      case 'center':
      case 'justify':
        return { display: 'flex', justifyContent: 'center' };
      case 'right':
        return { display: 'flex', justifyContent: 'flex-end' };
      case 'left':
        return { display: 'flex', justifyContent: 'flex-start' };
      default:
        return { display: 'flex', justifyContent: 'flex-start' };
    }
  };

  return (
    <NodeViewWrapper ref={containerRef} className={cn('tiptap image-node relative overflow-hidden')} style={getContainerStyle()}>
      <div className={'relative inline-block max-w-full rounded-md'}>
        <Image ref={ref} src={src} alt={alt} title={title} style={getImageStyle()} onLoad={handleMediaLoad} className={'m-0 rounded-md'} />
        {selected && isEditable && (
          <>
            <ResizableButton side="left" handleMouseDown={handleMouseDown} />
            <ResizableButton side="right" handleMouseDown={handleMouseDown} />
            <RemoveFloatButton editor={editor} pos={getPos()} />
          </>
        )}
      </div>
    </NodeViewWrapper>
  );
}
